module.exports = __webpack_public_path__ + "components/bookings-online-payment-method/static/paypal-ac487a154c688b3161c34f493d540524.svg";